import { createSlice } from "@reduxjs/toolkit";

export const searchPartnerSlice = createSlice({
  name: "searchPartner",
  initialState: {
    searchData: [],
    partnerTypeList: [],
    lockerTypeList: [],
    partnerList: [],
    partnerCategoryList: [],
    partnerSearchField: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : null,
      partnerId: "-2",
      partnerTypeId: "-2",
      partnerCategoryNo: "-2",
      lockerTypeId: "-2",
    },
  },
  reducers: {
    setPartnerSearchFieldReducer: (state, actions) => {
      const valueName = Object.keys(actions.payload);
      const tempObj = state.searchField;
      tempObj[valueName[0]] = actions.payload[valueName[0]];
      state.searchField = tempObj;
    },
    getPartnersReducer: (state, actions) => {
      state.partnerList = actions.payload;
    },
    getPartnerTypeReducer: (state, actions) => {
      state.partnerTypeList = actions.payload;
    },
    getLockerTypeReducer: (state, actions) => {
      state.lockerTypeList = actions.payload;
    },
    getPartnerReducer: (state, actions) => {
      state.partnerList = actions.payload;
    },
    getPartnerCategoryReducer: (state, actions) => {
      state.partnerCategoryList = actions.payload;
    },
    handleOnPartnerSearchFilterChangedReducer: (state, actions) => {
      const { name, value } = actions.payload;
      let tempData = { ...state.partnerSearchField };
      tempData[name] = value;
      state.partnerSearchField = tempData;
    },
    setSearchDataReducer: (state, actions) => {
      state.searchData = actions.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getPartnersReducer,
  getLockerTypeReducer,
  getPartnerTypeReducer,
  getPartnerCategoryReducer,
  getPartnerReducer,
  setSearchFieldReducer,
  handleOnPartnerSearchFilterChangedReducer,
  setSearchDataReducer,
} = searchPartnerSlice.actions;

export default searchPartnerSlice.reducer;
